export default "__VITE_ASSET__Cu_GQLqt__"